import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { ApiAuctionsService } from '../../../core/service/api-auctions.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-joinAuction',
  templateUrl: './joinAuction.component.html',
  styleUrls: []
})
export class JoinAuctionComponent implements OnInit {
  loading =false;
  constructor(
    public dialogRef: MatDialogRef<JoinAuctionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _auctionApi:ApiAuctionsService,
    public _config : ConfigService, 
    private _translate: TranslateService
  ) { }

  ngOnInit() {
    console.log(this.data);
    
  }
  join(){
    this.loading = true;
    this._auctionApi.joinAuction(this.data.id).subscribe({
      next : (data) =>{
        this.loading = false;
        this._config.toastrService.success(this._translate.instant('bidders.Join Successfully'));
        this.dialogRef.close('success');
      }, error: (error: any) => {
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);
        // });
        this._config.showErrors(error);

        this.loading = false;
      }
    })
  }
}
